module.exports = __webpack_public_path__ + "img/mobile_btn.a4b43d30.png";